export default __webpack_public_path__ + "static/media/Iconly-Bulk-Close Square.78eb0113.svg";